//import styles from './page_title.module.css'
export default function MenuAvatar(props) {
  return (
  <div>
    {props.user.email}
  </div>
  )
}